import { CreateUnifiedClassPersonSkillDTO } from "@/api/dto/skills/CreateUnifiedClassPersonSkill";
import { EditUnifiedClassPersonSkillDTO } from "@/api/dto/skills/EditUnifiedClassPersonSkillDTO";

export interface ISkillAssignment {
  skill: number | null;
  rating: number | null;
  instructor: string | null;
  comment: string | null;
}

export class SkillAssignment implements ISkillAssignment {
  skill: number | null;
  rating: number | null;
  instructor: string | null;
  comment: string | null;

  constructor(config?: Partial<ISkillAssignment>) {
    this.skill = config?.skill || null;
    this.rating = config?.rating || null;
    this.instructor = config?.instructor || null;
    this.comment = config?.comment || null;
  }

  toDTO(personId: number): CreateUnifiedClassPersonSkillDTO | null {
    if (this.skill != null && this.rating != null) {
      return {
        personId,
        skillId: this.skill,
        assessmentId: this.rating,
        instructor: this.instructor,
        comments: this.comment,
      };
    }

    return null;
  }
}
